import React from "react";
import {
  Container, Row, Col, Card, CardHeader, CardBody, Button,
  Input, Badge, Alert, Table, Collapse
} from "reactstrap";
import { PulseLoader } from "react-spinners";
import { connect } from "react-redux";
import api from "./../../Api.js";
import ReactApexChart from 'react-apexcharts';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

var STUDENTS_PER_PAGE = 50;
var CLASSROOMS_PER_PAGE = 15;

class AdminPerformanceExport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      data: null,
      startDate: "",
      endDate: "",
      loadingExport: false,
      loadingPdf: false,
      exportError: null,
      exportSuccess: null,
      showExportMenu: false,
      expandedClassrooms: {},
      classroomSearch: "",
      classroomSearchDebounced: "",
      studentSearches: {},
      visibleClassrooms: CLASSROOMS_PER_PAGE,
      // Lazy load de alunos por turma
      classroomStudents: {},       // classroomId -> { students, total, page, pages, loading }
      studentVisibleCount: {}      // classroomId -> numero visivel (paginacao local)
    };
    this._searchTimer = null;
    this.loadDashboard = this.loadDashboard.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleExportXlsxAlunos = this.handleExportXlsxAlunos.bind(this);
    this.handleExportPdf = this.handleExportPdf.bind(this);
    this.handleExportPdfAlunos = this.handleExportPdfAlunos.bind(this);
    this._dashboardRef = React.createRef();
    this._loadRequestId = 0;
  }

  t(key, fallback) {
    return (this.props.translate && this.props.translate[key]) || fallback || key;
  }

  getCompanyId() {
    return this.props.user && this.props.user.preference ? this.props.user.preference.selectcompany : null;
  }

  componentDidMount() {
    this.loadDashboard();
    this._closeExportMenu = function(e) {
      if (this.state.showExportMenu) {
        this.setState({ showExportMenu: false });
      }
    }.bind(this);
    document.addEventListener('click', this._closeExportMenu);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this._closeExportMenu);
    if (this._searchTimer) clearTimeout(this._searchTimer);
  }

  setClassroomSearch(value) {
    var self = this;
    this.setState({ classroomSearch: value });
    if (this._searchTimer) clearTimeout(this._searchTimer);
    this._searchTimer = setTimeout(function() {
      self.setState({ classroomSearchDebounced: value, visibleClassrooms: CLASSROOMS_PER_PAGE });
    }, 250);
  }

  componentDidUpdate(prevProps) {
    var prev = prevProps.user && prevProps.user.preference ? prevProps.user.preference.selectcompany : null;
    var curr = this.getCompanyId();
    if (prev !== curr && curr) this.loadDashboard();
  }

  async loadDashboard() {
    var companyId = this.getCompanyId();
    if (!companyId) { this.setState({ error: "Selecione uma empresa no menu superior.", loading: false, data: null }); return; }
    this._loadRequestId++;
    var requestId = this._loadRequestId;
    this.setState({ loading: true, error: null, classroomStudents: {}, studentVisibleCount: {}, visibleClassrooms: CLASSROOMS_PER_PAGE });
    try {
      var params = { companyId: companyId };
      if (this.state.startDate) params.startDate = this.state.startDate;
      if (this.state.endDate) params.endDate = this.state.endDate;
      var res = await api.getPerformanceDashboard(params);
      if (requestId !== this._loadRequestId) return;
      this.setState({ data: res.data, loading: false, expandedClassrooms: {}, studentSearches: {} });
    } catch (err) {
      if (requestId !== this._loadRequestId) return;
      var msg = err.response && err.response.data && err.response.data.msg ? err.response.data.msg : "Erro ao carregar dashboard.";
      this.setState({ error: msg, loading: false });
    }
  }

  // Carrega alunos de uma turma (lazy, paginado no backend)
  async loadClassroomStudents(classroomId, page) {
    var companyId = this.getCompanyId();
    if (!companyId) return;

    // Marcar loading
    this.setState(function(prev) {
      var cs = Object.assign({}, prev.classroomStudents);
      var existing = cs[classroomId] || { students: [], total: 0, page: 0, pages: 0 };
      cs[classroomId] = Object.assign({}, existing, { loading: true });
      return { classroomStudents: cs };
    });

    try {
      var params = {
        companyId: companyId,
        classroomId: classroomId,
        page: page || 1,
        limit: STUDENTS_PER_PAGE
      };
      if (this.state.startDate) params.startDate = this.state.startDate;
      if (this.state.endDate) params.endDate = this.state.endDate;

      var res = await api.getPerformanceStudents(params);
      var data = res.data || {};

      this.setState(function(prev) {
        var cs = Object.assign({}, prev.classroomStudents);
        var existing = cs[classroomId] || { students: [] };
        // Se pagina 1, substitui. Se pagina > 1, concatena
        var newStudents = (page || 1) === 1
          ? (data.students || [])
          : (existing.students || []).concat(data.students || []);

        cs[classroomId] = {
          students: newStudents,
          total: data.total || 0,
          page: data.page || 1,
          pages: data.pages || 1,
          loading: false
        };
        var vc = Object.assign({}, prev.studentVisibleCount);
        if (!vc[classroomId]) vc[classroomId] = STUDENTS_PER_PAGE;
        return { classroomStudents: cs, studentVisibleCount: vc };
      });
    } catch (err) {
      console.error('Erro ao carregar alunos da turma:', err);
      this.setState(function(prev) {
        var cs = Object.assign({}, prev.classroomStudents);
        cs[classroomId] = Object.assign({}, cs[classroomId] || {}, { loading: false });
        return { classroomStudents: cs };
      });
    }
  }

  async doExport(type) {
    var companyId = this.getCompanyId();
    if (!companyId) {
      this.setState({ exportError: "Selecione uma empresa no menu superior." });
      return;
    }
    this.setState({ loadingExport: true, exportError: null, exportSuccess: null });
    try {
      var body = { companyId: Number(companyId), type: type };
      if (this.state.startDate) body.startDate = this.state.startDate;
      if (this.state.endDate) body.endDate = this.state.endDate;
      var res = await api.exportPerformance(body);
      var data = res.data || {};
      if (data.url) {
        var backendUrl = sessionStorage.getItem("backend") || "";
        var baseUrl = backendUrl.replace(/\/api\/?$/, "");
        var link = document.createElement("a");
        link.href = baseUrl + data.url;
        link.download = data.filename || "desempenho.xlsx";
        document.body.appendChild(link); link.click(); document.body.removeChild(link);
        this.setState({ exportSuccess: "Planilha gerada! " + data.totalStudents + " alunos — " + (data.sheets || []).join(', '), loadingExport: false });
      }
    } catch (err) {
      var msg = err.response && err.response.data && err.response.data.msg ? err.response.data.msg : "Erro ao exportar.";
      this.setState({ exportError: msg, loadingExport: false });
    }
  }

  async handleExport() { await this.doExport('turmas'); }
  async handleExportXlsxAlunos() { await this.doExport('alunos'); }

  handleExportPdf() {
    // PDF via jsPDF + autoTable (sem html2canvas — mais confiavel)
    var data = this.state.data;
    if (!data || !data.classrooms) return;
    this.setState({ loadingPdf: true, exportError: null });

    try {
      var s = data.summary || {};
      var classrooms = data.classrooms || [];
      var pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
      var pageWidth = pdf.internal.pageSize.getWidth();
      var pageHeight = pdf.internal.pageSize.getHeight();

      // Titulo
      pdf.setFontSize(18);
      pdf.setFont(undefined, 'bold');
      pdf.text('Dashboard de Desempenho', 14, 18);
      pdf.setFontSize(10);
      pdf.setFont(undefined, 'normal');
      pdf.setTextColor(100);
      pdf.text('Gerado em ' + new Date().toLocaleDateString('pt-BR') + ' ' + new Date().toLocaleTimeString('pt-BR'), 14, 24);

      // KPIs
      pdf.setTextColor(60);
      pdf.setFontSize(9);
      var kpiText = 'Total: ' + (s.totalStudents || 0) + ' alunos | ' + (s.totalClassrooms || 0) + ' turmas | Tempo total: ' + (s.totalStudyTimeFormatted || '0min') + ' | Media/aluno: ' + (s.avgStudyTimeFormatted || '0min') + ' | Engajamento: ' + (s.engagementRate || 0) + '%';
      pdf.text(kpiText, 14, 30);

      // Tabela de turmas
      var turmaHead = [['Turma', 'Alunos', 'Ativos', 'Engaj.', 'Aulas', 'Tempo/Aluno', 'Sessoes', 'Quiz', 'Freq.']];
      var turmaBody = classrooms.map(function(cr) {
        var a = cr.avg || {};
        return [
          cr.classroomName || '',
          String(cr.studentCount || 0),
          String(cr.activeStudents || 0),
          (a.engagementRate || 0) + '%',
          String(a.lessonsCompleted || 0),
          a.totalStudyFormatted || '0min',
          String(a.sessions || 0),
          a.avgQuiz !== null && a.avgQuiz !== undefined ? a.avgQuiz + '%' : 'N/A',
          a.attendanceRate !== null && a.attendanceRate !== undefined ? a.attendanceRate + '%' : 'N/A'
        ];
      });

      autoTable(pdf, {
        startY: 35,
        head: turmaHead,
        body: turmaBody,
        theme: 'grid',
        headStyles: { fillColor: [94, 114, 228], textColor: 255, fontSize: 8, fontStyle: 'bold', halign: 'center' },
        bodyStyles: { fontSize: 7.5, cellPadding: 2 },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { halign: 'center', cellWidth: 18 },
          2: { halign: 'center', cellWidth: 18 },
          3: { halign: 'center', cellWidth: 18 },
          4: { halign: 'center', cellWidth: 18 },
          5: { halign: 'center', cellWidth: 28 },
          6: { halign: 'center', cellWidth: 20 },
          7: { halign: 'center', cellWidth: 18 },
          8: { halign: 'center', cellWidth: 18 }
        },
        alternateRowStyles: { fillColor: [245, 247, 250] },
        margin: { left: 14, right: 14 },
        didDrawPage: function() {
          pdf.setFontSize(8);
          pdf.setTextColor(150);
          pdf.text('Pagina ' + pdf.internal.getCurrentPageInfo().pageNumber, pageWidth - 30, pageHeight - 8);
        }
      });

      pdf.save('desempenho_turmas_' + new Date().toISOString().slice(0, 10) + '.pdf');
      this.setState({ loadingPdf: false });

    } catch (err) {
      console.error('Erro ao gerar PDF:', err);
      this.setState({ loadingPdf: false, exportError: 'Erro ao gerar PDF: ' + (err.message || 'Tente novamente.') });
    }
  }

  handleExportPdfAlunos() {
    var data = this.state.data;
    if (!data || !data.classrooms) return;
    this.setState({ loadingPdf: true, exportError: null });

    try {
      var pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
      var pageWidth = pdf.internal.pageSize.getWidth();
      var pageHeight = pdf.internal.pageSize.getHeight();

      // Titulo
      pdf.setFontSize(18);
      pdf.setFont(undefined, 'bold');
      pdf.text('Desempenho dos Alunos', 14, 18);
      pdf.setFontSize(10);
      pdf.setFont(undefined, 'normal');
      pdf.setTextColor(100);
      pdf.text('Gerado em ' + new Date().toLocaleDateString('pt-BR') + ' ' + new Date().toLocaleTimeString('pt-BR'), 14, 24);

      // KPIs no topo
      var s = data.summary || {};
      var kpiText = 'Total: ' + (s.totalStudents || 0) + ' alunos | ' + (s.totalClassrooms || 0) + ' turmas | Tempo total: ' + (s.totalStudyTimeFormatted || '0min') + ' | Media/aluno: ' + (s.avgStudyTimeFormatted || '0min') + ' | Engajamento: ' + (s.engagementRate || 0) + '%';
      pdf.setTextColor(60);
      pdf.setFontSize(9);
      pdf.text(kpiText, 14, 30);

      // Consolidar alunos a partir dos dados carregados em classroomStudents
      var classroomStudents = this.state.classroomStudents;
      var studentMap = {};
      var classrooms = data.classrooms || [];

      // Tentar usar dados ja carregados via lazy load
      var hasLoadedStudents = false;
      Object.keys(classroomStudents).forEach(function(cid) {
        var csData = classroomStudents[cid];
        if (csData && csData.students && csData.students.length > 0) {
          hasLoadedStudents = true;
          csData.students.forEach(function(st) {
            if (!studentMap[st.userId]) {
              studentMap[st.userId] = {
                name: (st.name || '') + ' ' + (st.lastName || ''),
                email: st.email || '',
                totalSeconds: 0,
                sessions: 0,
                lessonsCompleted: 0,
                distinctLessons: 0,
                quizSum: 0,
                quizCount: 0,
                presences: 0,
                totalClasses: 0,
                lastActivity: null
              };
            }
            var m = studentMap[st.userId];
            m.totalSeconds += st.totalSeconds || 0;
            m.sessions += st.sessions || 0;
            m.lessonsCompleted += st.lessonsCompleted || 0;
            m.distinctLessons += st.distinctLessons || 0;
            if (st.avgQuiz !== null && st.avgQuiz !== undefined) { m.quizSum += st.avgQuiz; m.quizCount++; }
            m.presences += st.presences || 0;
            m.totalClasses += st.totalClasses || 0;
            if (st.lastActivity && (!m.lastActivity || st.lastActivity > m.lastActivity)) m.lastActivity = st.lastActivity;
          });
        }
      });

      if (!hasLoadedStudents) {
        this.setState({ loadingPdf: false, exportError: 'Expanda ao menos uma turma antes de gerar o PDF de alunos, para carregar os dados dos alunos.' });
        return;
      }

      var alunos = Object.keys(studentMap).map(function(uid) {
        var m = studentMap[uid];
        var totalMin = Math.round(m.totalSeconds / 60);
        var h = Math.floor(totalMin / 60);
        var min = totalMin % 60;
        var tempoFormatted = totalMin < 60 ? totalMin + 'min' : h + 'h ' + min + 'min';
        var avgQuiz = m.quizCount > 0 ? Math.round(m.quizSum / m.quizCount * 10) / 10 : null;
        var freq = m.totalClasses > 0 ? Math.round(m.presences / m.totalClasses * 1000) / 10 : null;

        return {
          name: m.name,
          lessonsCompleted: m.lessonsCompleted,
          tempoFormatted: tempoFormatted,
          sessions: m.sessions,
          distinctLessons: m.distinctLessons,
          avgQuiz: avgQuiz,
          freq: freq,
          lastActivity: m.lastActivity ? new Date(m.lastActivity).toLocaleDateString('pt-BR') : '-'
        };
      });

      alunos.sort(function(a, b) { return b.sessions - a.sessions; });

      var tableHead = [['Aluno', 'Aulas Concl.', 'Tempo no Portal', 'Sessoes', 'Aulas Dist.', 'Media Quiz', 'Frequencia', 'Ultima Ativ.']];
      var tableBody = alunos.map(function(a) {
        return [
          a.name,
          String(a.lessonsCompleted),
          a.tempoFormatted,
          String(a.sessions),
          String(a.distinctLessons),
          a.avgQuiz !== null ? a.avgQuiz + '%' : 'N/A',
          a.freq !== null ? a.freq + '%' : 'N/A',
          a.lastActivity
        ];
      });

      autoTable(pdf, {
        startY: 35,
        head: tableHead,
        body: tableBody,
        theme: 'grid',
        headStyles: { fillColor: [94, 114, 228], textColor: 255, fontSize: 8, fontStyle: 'bold', halign: 'center' },
        bodyStyles: { fontSize: 7.5, cellPadding: 2 },
        columnStyles: {
          0: { cellWidth: 55 },
          1: { halign: 'center', cellWidth: 22 },
          2: { halign: 'center', cellWidth: 30 },
          3: { halign: 'center', cellWidth: 20 },
          4: { halign: 'center', cellWidth: 22 },
          5: { halign: 'center', cellWidth: 22 },
          6: { halign: 'center', cellWidth: 22 },
          7: { halign: 'center', cellWidth: 25 }
        },
        alternateRowStyles: { fillColor: [245, 247, 250] },
        margin: { left: 14, right: 14 },
        didDrawPage: function() {
          pdf.setFontSize(8);
          pdf.setTextColor(150);
          pdf.text('Pagina ' + pdf.internal.getCurrentPageInfo().pageNumber, pageWidth - 30, pageHeight - 8);
        }
      });

      pdf.save('desempenho_alunos_' + new Date().toISOString().slice(0, 10) + '.pdf');
      this.setState({ loadingPdf: false });

    } catch (err) {
      console.error('Erro ao gerar PDF de alunos:', err);
      this.setState({ loadingPdf: false, exportError: 'Erro ao gerar PDF: ' + (err.message || 'Tente novamente.') });
    }
  }

  clearDateFilter() { this.setState({ startDate: "", endDate: "" }, () => this.loadDashboard()); }

  toggleClassroom(id) {
    var self = this;
    this.setState(function(prev) {
      var expanded = Object.assign({}, prev.expandedClassrooms);
      expanded[id] = !expanded[id];
      // Se expandindo e alunos nao carregados ainda, carregar
      if (expanded[id] && !prev.classroomStudents[id]) {
        setTimeout(function() { self.loadClassroomStudents(id, 1); }, 0);
      }
      return { expandedClassrooms: expanded };
    });
  }

  expandAll() {
    var self = this;
    var data = this.state.data;
    if (!data || !data.classrooms) return;
    var expanded = {};
    data.classrooms.forEach(function(c) { expanded[c.classroomId] = true; });
    this.setState({ expandedClassrooms: expanded }, function() {
      // Carregar alunos das turmas que ainda nao foram carregadas
      data.classrooms.forEach(function(c) {
        if (!self.state.classroomStudents[c.classroomId]) {
          self.loadClassroomStudents(c.classroomId, 1);
        }
      });
    });
  }

  collapseAll() { this.setState({ expandedClassrooms: {} }); }

  setStudentSearch(classroomId, value) {
    this.setState(function(prev) {
      var searches = Object.assign({}, prev.studentSearches);
      searches[classroomId] = value;
      return { studentSearches: searches };
    });
  }

  showMoreStudents(classroomId) {
    var self = this;
    this.setState(function(prev) {
      var vc = Object.assign({}, prev.studentVisibleCount);
      vc[classroomId] = (vc[classroomId] || STUDENTS_PER_PAGE) + STUDENTS_PER_PAGE;

      // Se precisa de mais dados do backend
      var csData = prev.classroomStudents[classroomId];
      if (csData && vc[classroomId] > csData.students.length && csData.page < csData.pages) {
        setTimeout(function() { self.loadClassroomStudents(classroomId, csData.page + 1); }, 0);
      }

      return { studentVisibleCount: vc };
    });
  }

  // =============================================
  // KPI Cards
  // =============================================
  renderKPIs() {
    if (!this.state.data || !this.state.data.summary) return null;
    var s = this.state.data.summary;
    var kpis = [
      { label: "Alunos", value: s.totalStudents, icon: "fas fa-user-graduate", color: "#5e72e4", bg: "#edf2ff" },
      { label: "Turmas", value: s.totalClassrooms, icon: "fas fa-chalkboard", color: "#2dce89", bg: "#e9f7ef" },
      { label: "Tempo Total", value: s.totalStudyTimeFormatted, icon: "fas fa-clock", color: "#fb6340", bg: "#fff0eb" },
      { label: "Tempo Medio/Aluno", value: s.avgStudyTimeFormatted, icon: "fas fa-hourglass-half", color: "#8965e0", bg: "#f3eeff" },
      { label: "Media Quiz", value: s.avgQuizScore > 0 ? s.avgQuizScore + "%" : "N/A", icon: "fas fa-star", color: "#ffd600", bg: "#fffde5" },
      { label: "Frequencia", value: s.attendanceRate > 0 ? s.attendanceRate + "%" : "N/A", icon: "fas fa-calendar-check", color: "#2dce89", bg: "#e9f7ef" },
      { label: "Engajamento", value: s.engagementRate + "%", sub: s.activeStudents + " ativos / " + s.inactiveStudents + " inativos", icon: "fas fa-chart-line", color: "#f5365c", bg: "#ffe8ec" }
    ];
    return (
      <Row className="mb-4">
        {kpis.map(function(k, i) {
          return (
            <Col xl="3" lg="4" md="6" className="mb-3" key={i}>
              <Card className="shadow-sm border-0 h-100" style={{ borderLeft: "4px solid " + k.color, borderRadius: "8px" }}>
                <CardBody className="py-3 px-3">
                  <Row className="align-items-center no-gutters">
                    <Col xs="auto" className="pr-3">
                      <div style={{ width: 42, height: 42, borderRadius: "50%", backgroundColor: k.bg, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <i className={k.icon} style={{ fontSize: "1rem", color: k.color }}></i>
                      </div>
                    </Col>
                    <Col>
                      <h4 className="mb-0" style={{ fontSize: "1.1rem" }}>{k.value}</h4>
                      <small className="text-muted">{k.label}</small>
                      {k.sub && <small className="text-muted d-block" style={{ fontSize: "0.7rem" }}>{k.sub}</small>}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          );
        })}
      </Row>
    );
  }

  // =============================================
  // Graficos
  // =============================================
  renderCharts() {
    var data = this.state.data;
    if (!data) return null;
    var cs = data.classrooms || [];
    if (cs.length === 0) return null;

    var top = cs.slice(0, 10);
    var barCat = top.map(function(c) { return c.classroomName.length > 30 ? c.classroomName.substr(0, 30) + '...' : c.classroomName; });
    var barStudy = top.map(function(c) { return (c.avg || {}).totalStudyMinutes || 0; });
    var barSessions = top.map(function(c) { return (c.avg || {}).sessions || 0; });

    var barOptions = {
      chart: { type: "bar", toolbar: { show: false }, fontFamily: 'inherit' },
      plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '60%' } },
      colors: ["#5e72e4"],
      xaxis: { categories: barCat, title: { text: "min/aluno" } },
      yaxis: { labels: { style: { fontSize: '11px' } } },
      dataLabels: { enabled: true, formatter: function(v) { return Math.round(v) + 'min'; }, style: { fontSize: '10px' } },
      tooltip: { y: { formatter: function(v) { return Math.round(v) + ' min'; } } }
    };

    var engCat = barCat;
    var engData = top.map(function(c) { return (c.avg || {}).engagementRate || 0; });
    var engOptions = {
      chart: { type: "bar", toolbar: { show: false }, fontFamily: 'inherit' },
      plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '60%' } },
      colors: ["#2dce89"],
      xaxis: { categories: engCat, max: 100, title: { text: "% alunos ativos" } },
      yaxis: { labels: { style: { fontSize: '11px' } } },
      dataLabels: { enabled: true, formatter: function(v) { return v + '%'; }, style: { fontSize: '10px' } }
    };

    // Donut: usar dados agregados das turmas (sem precisar dos alunos individuais)
    // Nao temos distribuicao individual sem lazy load, entao mostra engajamento
    var sessionOptions = {
      chart: { type: "bar", toolbar: { show: false }, fontFamily: 'inherit' },
      plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '60%' } },
      colors: ["#8965e0"],
      xaxis: { categories: barCat, title: { text: "sessoes/aluno" } },
      yaxis: { labels: { style: { fontSize: '11px' } } },
      dataLabels: { enabled: true, formatter: function(v) { return v.toFixed(1); }, style: { fontSize: '10px' } }
    };

    // Donut quiz: usar avg.avgQuiz das turmas
    var quizDist = { advanced: 0, intermediate: 0, basic: 0, none: 0 };
    cs.forEach(function(c) {
      var q = (c.avg || {}).avgQuiz;
      if (q === null || q === undefined) quizDist.none++;
      else if (q >= 90) quizDist.advanced++;
      else if (q >= 70) quizDist.intermediate++;
      else quizDist.basic++;
    });
    var quizLabels = ["Turmas 90+", "Turmas 70-89", "Turmas <70", "Sem quiz"];
    var quizSeries = [quizDist.advanced, quizDist.intermediate, quizDist.basic, quizDist.none];
    var quizTotal = quizSeries.reduce(function(a, b) { return a + b; }, 0);
    var quizOptions = {
      chart: { type: "donut", fontFamily: 'inherit' },
      labels: quizLabels,
      colors: ["#2dce89", "#5e72e4", "#ffd600", "#adb5bd"],
      legend: { position: "bottom", fontSize: '12px' },
      tooltip: { y: { formatter: function(v) { return v + ' turmas'; } } }
    };

    var chartHeight = Math.max(280, top.length * 32);

    return (
      <React.Fragment>
        <Row className="mb-4">
          <Col lg="8" className="mb-3">
            <Card className="shadow-sm border-0 h-100" style={{ borderRadius: "8px" }}>
              <CardHeader className="bg-white border-0 pb-0">
                <h5 className="mb-0"><i className="fas fa-clock text-primary mr-2"></i>Tempo medio de estudo por turma</h5>
                <small className="text-muted">Media de minutos por aluno em cada turma</small>
              </CardHeader>
              <CardBody>
                <ReactApexChart type="bar" series={[{ name: "Tempo/Aluno", data: barStudy }]} options={barOptions} height={chartHeight} />
              </CardBody>
            </Card>
          </Col>
          <Col lg="4" className="mb-3">
            <Card className="shadow-sm border-0 h-100" style={{ borderRadius: "8px" }}>
              <CardHeader className="bg-white border-0 pb-0">
                <h5 className="mb-0"><i className="fas fa-star text-warning mr-2"></i>Desempenho em Quiz</h5>
                <small className="text-muted">Distribuicao por media das turmas</small>
              </CardHeader>
              <CardBody>
                {quizTotal > 0 ? (
                  <ReactApexChart type="donut" series={quizSeries} options={quizOptions} height={280} />
                ) : (
                  <p className="text-muted text-center py-4">Nenhum quiz realizado</p>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col lg="6" className="mb-3">
            <Card className="shadow-sm border-0 h-100" style={{ borderRadius: "8px" }}>
              <CardHeader className="bg-white border-0 pb-0">
                <h5 className="mb-0"><i className="fas fa-chart-line text-success mr-2"></i>Engajamento por turma</h5>
                <small className="text-muted">% de alunos que iniciaram alguma atividade</small>
              </CardHeader>
              <CardBody>
                <ReactApexChart type="bar" series={[{ name: "Engajamento", data: engData }]} options={engOptions} height={chartHeight} />
              </CardBody>
            </Card>
          </Col>
          <Col lg="6" className="mb-3">
            <Card className="shadow-sm border-0 h-100" style={{ borderRadius: "8px" }}>
              <CardHeader className="bg-white border-0 pb-0">
                <h5 className="mb-0"><i className="fas fa-redo text-purple mr-2"></i>Media de sessoes por turma</h5>
                <small className="text-muted">Quantidade media de sessoes por aluno</small>
              </CardHeader>
              <CardBody>
                <ReactApexChart type="bar" series={[{ name: "Sessoes/Aluno", data: barSessions }]} options={sessionOptions} height={chartHeight} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  // =============================================
  // Card de uma turma (medias + tabela de alunos lazy)
  // =============================================
  renderClassroomCard(classroom) {
    var self = this;
    var id = classroom.classroomId;
    var expanded = !!this.state.expandedClassrooms[id];
    var avg = classroom.avg || {};
    var totals = classroom.totals || {};
    var searchValue = this.state.studentSearches[id] || '';

    var engColor = (avg.engagementRate || 0) >= 80 ? "success" : (avg.engagementRate || 0) >= 50 ? "warning" : "danger";
    var quizColor = avg.avgQuiz !== null && avg.avgQuiz !== undefined ? (avg.avgQuiz >= 90 ? "success" : avg.avgQuiz >= 70 ? "primary" : avg.avgQuiz >= 50 ? "warning" : "danger") : "secondary";

    // Dados de alunos carregados via lazy load
    var csData = this.state.classroomStudents[id];
    var studentsLoading = csData ? csData.loading : false;
    var allStudents = csData ? (csData.students || []) : [];
    var totalServerStudents = csData ? csData.total : classroom.studentCount;
    var hasMoreOnServer = csData ? (csData.page < csData.pages) : false;

    // Filtrar alunos por busca
    var students = allStudents;
    if (searchValue.trim()) {
      var term = searchValue.toLowerCase().trim();
      students = students.filter(function(s) {
        return ((s.name || '') + ' ' + (s.lastName || '') + ' ' + (s.email || '')).toLowerCase().indexOf(term) !== -1;
      });
    }

    // Paginacao local
    var visibleCount = this.state.studentVisibleCount[id] || STUDENTS_PER_PAGE;
    var visibleStudents = students.slice(0, visibleCount);
    var hasMoreLocal = students.length > visibleCount || hasMoreOnServer;

    return (
      <Card className="shadow-sm border-0 mb-3" key={id} style={{ borderRadius: "8px", overflow: "hidden" }}>
        <div
          onClick={function() { self.toggleClassroom(id); }}
          style={{ cursor: "pointer", padding: "16px 20px", backgroundColor: expanded ? "#f8f9fe" : "#fff", borderBottom: expanded ? "1px solid #e9ecef" : "none", transition: "background-color 0.15s" }}
        >
          <Row className="align-items-center">
            <Col xs="auto" className="pr-2">
              <i className={expanded ? "fas fa-chevron-down text-primary" : "fas fa-chevron-right text-muted"} style={{ fontSize: "0.85rem", width: "16px" }}></i>
            </Col>
            <Col>
              <h5 className="mb-0">{classroom.classroomName}</h5>
              {classroom.courseName && <small className="text-muted">{classroom.courseName}</small>}
            </Col>
            <Col xs="auto">
              <Badge color="light" className="mr-2" style={{ fontSize: "0.8rem" }}>
                <i className="fas fa-users mr-1"></i>{classroom.studentCount} alunos
              </Badge>
              <Badge color={engColor} style={{ fontSize: "0.8rem" }}>
                {avg.engagementRate || 0}% engajamento
              </Badge>
            </Col>
          </Row>

          <Row className="mt-3" style={{ fontSize: "0.82rem" }}>
            <Col xs="6" sm="4" md="3" lg className="mb-2">
              <div className="text-muted" style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>Aulas Concluidas</div>
              <strong>{avg.lessonsCompleted || 0}</strong>
              <small className="text-muted"> /aluno</small>
            </Col>
            <Col xs="6" sm="4" md="3" lg className="mb-2">
              <div className="text-muted" style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>Tempo Estudado</div>
              <strong>{avg.totalStudyFormatted || '0min'}</strong>
              <small className="text-muted"> /aluno</small>
            </Col>
            <Col xs="6" sm="4" md="3" lg className="mb-2">
              <div className="text-muted" style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>Sessoes</div>
              <strong>{avg.sessions || 0}</strong>
              <small className="text-muted"> /aluno</small>
            </Col>
            <Col xs="6" sm="4" md="3" lg className="mb-2">
              <div className="text-muted" style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>Aulas Distintas</div>
              <strong>{avg.distinctLessons || 0}</strong>
              <small className="text-muted"> /aluno</small>
            </Col>
            <Col xs="6" sm="4" md="3" lg className="mb-2">
              <div className="text-muted" style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>Tempo Consolidado</div>
              <strong>{avg.consolidatedTimeFormatted || '0min'}</strong>
            </Col>
            <Col xs="6" sm="4" md="3" lg className="mb-2">
              <div className="text-muted" style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>Tempo Medio/Unit</div>
              <strong>{avg.avgTimePerUnitFormatted || '0min'}</strong>
            </Col>
            <Col xs="6" sm="4" md="3" lg className="mb-2">
              <div className="text-muted" style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>Media Quiz</div>
              {avg.avgQuiz !== null && avg.avgQuiz !== undefined ? <Badge color={quizColor} style={{ fontSize: "0.82rem" }}>{avg.avgQuiz}%</Badge> : <span className="text-muted">N/A</span>}
            </Col>
            <Col xs="6" sm="4" md="3" lg className="mb-2">
              <div className="text-muted" style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>Frequencia</div>
              <strong>{avg.attendanceRate !== null && avg.attendanceRate !== undefined ? avg.attendanceRate + "%" : "N/A"}</strong>
            </Col>
          </Row>
        </div>

        <Collapse isOpen={expanded}>
          <CardBody className="pt-2">
            <Row className="mb-2 align-items-center">
              <Col md="4">
                <Input type="text" bsSize="sm" placeholder="Buscar aluno nesta turma..."
                  value={searchValue}
                  onChange={function(e) { self.setStudentSearch(id, e.target.value); }}
                />
              </Col>
              <Col className="text-right">
                <small className="text-muted">
                  {allStudents.length > 0
                    ? (visibleStudents.length + ' de ' + totalServerStudents + ' alunos')
                    : (studentsLoading ? 'Carregando...' : '0 alunos')
                  }
                </small>
              </Col>
            </Row>

            {studentsLoading && allStudents.length === 0 ? (
              <div className="text-center py-4">
                <PulseLoader color="#5e72e4" size={10} />
                <p className="text-muted mt-2 mb-0">Carregando alunos...</p>
              </div>
            ) : (
              <React.Fragment>
                <div style={{ overflowX: "auto" }}>
                  <Table responsive hover size="sm" className="mb-0">
                    <thead className="thead-light">
                      <tr>
                        <th>#</th>
                        <th>Aluno</th>
                        <th className="text-center">Aulas Concl.</th>
                        <th className="text-center">Tempo Estudado</th>
                        <th className="text-center">Sessoes</th>
                        <th className="text-center">Aulas Dist.</th>
                        <th className="text-center">Tempo/Unit</th>
                        <th className="text-center">Media Quiz</th>
                        <th className="text-center">Frequencia</th>
                        <th>Ultima Atividade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {visibleStudents.length === 0 && !studentsLoading && (
                        <tr><td colSpan="10" className="text-center text-muted py-3">Nenhum aluno encontrado</td></tr>
                      )}
                      {visibleStudents.map(function(s, i) {
                        var qColor = s.avgQuiz !== null && s.avgQuiz !== undefined ? (s.avgQuiz >= 90 ? "success" : s.avgQuiz >= 70 ? "primary" : s.avgQuiz >= 50 ? "warning" : "danger") : null;
                        var inactive = !s.isActive;
                        return (
                          <tr key={s.userId + '_' + i} style={inactive ? { opacity: 0.6, backgroundColor: "#fafafa" } : {}}>
                            <td><small className="text-muted">{i + 1}</small></td>
                            <td>
                              <strong>{s.name} {s.lastName}</strong>
                              {s.email && <small className="text-muted d-block">{s.email}</small>}
                              {inactive && <Badge color="light" className="mt-1" style={{ fontSize: "0.65rem" }}>Sem atividade</Badge>}
                            </td>
                            <td className="text-center">{s.lessonsCompleted}</td>
                            <td className="text-center"><strong>{s.totalFormatted}</strong></td>
                            <td className="text-center">{s.sessions}</td>
                            <td className="text-center">{s.distinctLessons}</td>
                            <td className="text-center">{s.avgTimePerUnitMinutes > 0 ? s.avgTimePerUnitFormatted : <span className="text-muted">-</span>}</td>
                            <td className="text-center">
                              {s.avgQuiz !== null && s.avgQuiz !== undefined ? <Badge color={qColor}>{s.avgQuiz}%</Badge> : <span className="text-muted">N/A</span>}
                            </td>
                            <td className="text-center">
                              {s.attendanceRate !== null && s.attendanceRate !== undefined ? s.attendanceRate + "%" : <span className="text-muted">N/A</span>}
                            </td>
                            <td><small className="text-muted">{s.lastActivity ? new Date(s.lastActivity).toLocaleDateString('pt-BR') : '-'}</small></td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>

                {(hasMoreLocal || studentsLoading) && (
                  <div className="text-center mt-3">
                    {studentsLoading ? (
                      <PulseLoader color="#5e72e4" size={8} />
                    ) : (
                      <Button color="outline-primary" size="sm" onClick={function() { self.showMoreStudents(id); }}>
                        <i className="fas fa-plus mr-1"></i>Carregar mais alunos
                      </Button>
                    )}
                  </div>
                )}
              </React.Fragment>
            )}
          </CardBody>
        </Collapse>
      </Card>
    );
  }

  // =============================================
  // Lista de turmas
  // =============================================
  renderClassrooms() {
    var self = this;
    var data = this.state.data;
    if (!data) return null;
    var allClassrooms = data.classrooms || [];
    var search = this.state.classroomSearchDebounced.toLowerCase().trim();

    var filtered = allClassrooms;
    if (search) {
      filtered = allClassrooms.filter(function(c) {
        return (c.classroomName || '').toLowerCase().indexOf(search) !== -1 ||
               (c.courseName || '').toLowerCase().indexOf(search) !== -1;
      });
    }

    var visibleCount = this.state.visibleClassrooms;
    var visible = filtered.slice(0, visibleCount);
    var hasMore = filtered.length > visibleCount;

    return (
      <React.Fragment>
        <Row className="mb-3 align-items-center">
          <Col md="4">
            <h4 className="mb-0"><i className="fas fa-chalkboard text-primary mr-2"></i>Turmas <small className="text-muted">({filtered.length})</small></h4>
          </Col>
          <Col md="4">
            <Input type="text" bsSize="sm" placeholder="Filtrar turmas..."
              value={this.state.classroomSearch}
              onChange={function(e) { self.setClassroomSearch(e.target.value); }}
            />
          </Col>
          <Col md="4" className="text-right">
            <Button color="outline-primary" size="sm" className="mr-2" onClick={function() { self.expandAll(); }}>
              <i className="fas fa-expand-arrows-alt mr-1"></i>Expandir todas
            </Button>
            <Button color="outline-secondary" size="sm" onClick={function() { self.collapseAll(); }}>
              <i className="fas fa-compress-arrows-alt mr-1"></i>Recolher
            </Button>
          </Col>
        </Row>

        {filtered.length === 0 ? (
          <Alert color="info">Nenhuma turma encontrada</Alert>
        ) : (
          <React.Fragment>
            {visible.map(function(c) { return self.renderClassroomCard(c); })}
            {hasMore && (
              <div className="text-center py-3">
                <Button color="outline-primary" size="sm" onClick={function() { self.setState(function(p) { return { visibleClassrooms: p.visibleClassrooms + CLASSROOMS_PER_PAGE }; }); }}>
                  <i className="fas fa-plus mr-1"></i>Mostrar mais turmas ({filtered.length - visibleCount} restantes)
                </Button>
              </div>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }

  // =============================================
  // Render principal
  // =============================================
  render() {
    var self = this;
    var { loading, error, data, startDate, endDate, loadingExport, loadingPdf, exportError, exportSuccess } = this.state;

    if (error && !loading) {
      return (
        <Container className="mt-4" fluid>
          <Alert color="danger">
            <h4 className="mb-2">Desempenho</h4>
            <p>{error}</p>
            <Button color="primary" size="sm" onClick={this.loadDashboard}>Tentar novamente</Button>
          </Alert>
        </Container>
      );
    }

    return (
      <Container className="mt-4" fluid>
        <Row className="mb-3 align-items-center">
          <Col md="4">
            <h2 className="mb-1" style={{ fontWeight: 700 }}>
              <i className="fas fa-chart-bar text-primary mr-2"></i>Desempenho
            </h2>
            <p className="text-muted mb-0">Resumo geral das turmas e alunos</p>
          </Col>
          <Col md="8">
            <div className="d-flex align-items-center justify-content-end flex-wrap" style={{ gap: "8px" }}>
              <Input type="date" bsSize="sm" value={startDate} style={{ width: "145px" }}
                onChange={function(e) { self.setState({ startDate: e.target.value }); }} />
              <span className="text-muted">ate</span>
              <Input type="date" bsSize="sm" value={endDate} style={{ width: "145px" }}
                onChange={function(e) { self.setState({ endDate: e.target.value }); }} />
              <Button color="primary" size="sm" onClick={function() { self.loadDashboard(); }} disabled={loading}>
                <i className="fas fa-filter mr-1"></i>Filtrar
              </Button>
              {(startDate || endDate) && (
                <Button color="light" size="sm" onClick={function() { self.clearDateFilter(); }}>
                  <i className="fas fa-times"></i>
                </Button>
              )}
              <div style={{ borderLeft: "1px solid #dee2e6", height: "28px", margin: "0 4px" }}></div>
              {(loadingExport || loadingPdf) ? (
                <Button color="success" size="sm" disabled>
                  <PulseLoader color="#fff" size={6} /> <span className="ml-1">Gerando...</span>
                </Button>
              ) : (
                <div style={{ position: "relative", display: "inline-block" }}>
                  <Button color="success" size="sm" onClick={function(e) { e.stopPropagation(); e.nativeEvent.stopImmediatePropagation(); self.setState(function(p) { return { showExportMenu: !p.showExportMenu }; }); }} disabled={loading || !data}>
                    <i className="fas fa-download mr-1"></i>Exportar <i className="fas fa-caret-down ml-1"></i>
                  </Button>
                  {this.state.showExportMenu && (
                    <div style={{ position: "absolute", right: 0, top: "100%", marginTop: "4px", backgroundColor: "#fff", border: "1px solid #e0e0e0", borderRadius: "6px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: 1000, minWidth: "240px", overflow: "hidden" }}>
                      <div
                        style={{ padding: "10px 14px", cursor: "pointer", borderBottom: "1px solid #f0f0f0", fontSize: "0.85rem" }}
                        onClick={function() { self.setState({ showExportMenu: false }); self.handleExport(); }}
                        onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = '#f8f9fe'; }}
                        onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = '#fff'; }}
                      >
                        <i className="fas fa-file-excel text-success mr-2"></i>
                        <strong>Planilha de Turmas</strong>
                        <small className="text-muted d-block ml-4">Visao geral com medias por turma</small>
                      </div>
                      <div
                        style={{ padding: "10px 14px", cursor: "pointer", borderBottom: "1px solid #f0f0f0", fontSize: "0.85rem" }}
                        onClick={function() { self.setState({ showExportMenu: false }); self.handleExportXlsxAlunos(); }}
                        onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = '#f8f9fe'; }}
                        onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = '#fff'; }}
                      >
                        <i className="fas fa-file-excel text-success mr-2"></i>
                        <strong>Planilha de Alunos</strong>
                        <small className="text-muted d-block ml-4">Consolidado por aluno no curso</small>
                      </div>
                      <div
                        style={{ padding: "10px 14px", cursor: "pointer", borderBottom: "1px solid #f0f0f0", fontSize: "0.85rem" }}
                        onClick={function() { self.setState({ showExportMenu: false }); self.handleExportPdfAlunos(); }}
                        onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = '#f8f9fe'; }}
                        onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = '#fff'; }}
                      >
                        <i className="fas fa-file-pdf text-danger mr-2"></i>
                        <strong>PDF de Alunos</strong>
                        <small className="text-muted d-block ml-4">Tabela consolidada em PDF</small>
                      </div>
                      <div
                        style={{ padding: "10px 14px", cursor: "pointer", fontSize: "0.85rem" }}
                        onClick={function() { self.setState({ showExportMenu: false }); self.handleExportPdf(); }}
                        onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = '#f8f9fe'; }}
                        onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = '#fff'; }}
                      >
                        <i className="fas fa-file-pdf text-danger mr-2"></i>
                        <strong>PDF de Turmas</strong>
                        <small className="text-muted d-block ml-4">Tabela com medias por turma</small>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </Col>
        </Row>

        {exportError && <Alert color="danger" className="py-2 mb-3">{exportError}</Alert>}
        {exportSuccess && <Alert color="success" className="py-2 mb-3"><i className="fas fa-check mr-1"></i>{exportSuccess}</Alert>}

        {loading ? (
          <Row>
            <Col className="text-center py-5">
              <PulseLoader color="#5e72e4" size={15} />
              <p className="text-muted mt-3">Carregando dados de desempenho...</p>
            </Col>
          </Row>
        ) : data ? (
          <div ref={this._dashboardRef}>
            {this.renderKPIs()}
            {this.renderCharts()}
            {this.renderClassrooms()}
          </div>
        ) : null}
      </Container>
    );
  }
}

export default connect(function(state) {
  return { translate: state.translate, user: state.user, permission: state.permission };
})(AdminPerformanceExport);
